/**
 * Theme Models for Material 3 Advanced Theming System
 * These models support runtime theme switching with light/dark mode variants
 */

/**
 * Enum for available theme types
 */
export enum ThemeType {
  /** Brand theme - primary theme based on brand colors (can be replaced via build) */
  BRAND = "brand",
  /** Generic Theme A - for runtime testing and demos */
  GENERIC_A = "generic-a",
  /** Generic Theme B - for runtime testing and demos */
  GENERIC_B = "generic-b",
}

/**
 * Enum for theme color modes
 */
export enum ThemeMode {
  /** Light mode - default Material 3 light theme */
  LIGHT = "light",
  /** Dark mode - Material 3 dark theme variant */
  DARK = "dark",
}

/**
 * Interface for theme configuration
 */
export interface IThemeConfig {
  /** The selected theme type */
  themeType: ThemeType;
  /** The selected color mode (light/dark) */
  themeMode: ThemeMode;
}

/**
 * Constant for default theme configuration
 */
export const DEFAULT_THEME_CONFIG: IThemeConfig = {
  themeType: ThemeType.BRAND,
  themeMode: ThemeMode.LIGHT,
};

/**
 * LocalStorage key for theme persistence
 */
export const THEME_STORAGE_KEY = "viewer-theme-config";
